import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useGetChampionshipGames, useTeamColors } from 'hooks';
import { hexToRgba } from 'helpers';
import { setAllGamesInfo } from 'redux/games/actionCreators';
import { safeLogEvent } from 'firebase.js';

import {
  ChampionshipHeader,
  ErrorMessage,
  Loading,
  TopNav,
  // TEMP - Don't show login until later...
  // AuthContainer,
} from 'components';
import { DashboardChampionship } from 'components/Dashboard/DashboardChampionship';

import {
  BodyContainer,
  MainContainer,
  StyledHeader,
  StyledFooter,
} from 'components/App/style';

const ChampionshipPage = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries([...searchParams]);

  const {
    loading: isConfigLoading,
    error: isConfigError,
    data: configData,
  } = useSelector((state) => state.configuration);

  const {
    data: leaguesData,
    loading: leaguesLoading,
    error: leagueError,
  } = useSelector((state) => state.leagues);

  const {
    data: teamsData,
    status: teamsStatus,
    error: teamsError,
  } = useGetChampionshipGames({
    leagueId: params?.leagueId,
    league: params?.league,
  });

  const [backgroundColor, setBackgroundColor] = useState('');
  const { mainColorRgba } = useTeamColors();

  // Check if top nav is enabled
  const isTopNavEnabled = useSelector((state) => {
    const val = state.configuration?.data?.top_nav_enabled;
    return val === 1 || val === '1';
  });

  useEffect(() => {
    if (configData?.style_main_color) {
      setBackgroundColor(configData?.style_main_color);
    }
  }, [configData?.style_main_color]);

  useEffect(() => {
    if (teamsData) {
      dispatch(setAllGamesInfo(teamsData.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamsData]);

  if (isConfigLoading || leaguesLoading || teamsStatus === 'loading') {
    return <Loading />;
  }

  if (isConfigError) {
    safeLogEvent('select_content', {
      content_type: 'error',
      content_id: `Unable to load site configuration for ${window.location.href}`,
    });

    return (
      <ErrorMessage title=" Oops... Service currently unavailable. We are working on it. Please try again later." />
    );
  }

  if (leagueError || teamsError === 'error') {
    const message = leagueError || teamsError;
    safeLogEvent('select_content', {
      content_type: 'error',
      content_id: `Unable to get schedule data: ${message}. Site: ${window.location.href}`,
    });

    return <ErrorMessage />;
  }

  return (
    <BodyContainer
      $backgroundColor={backgroundColor ? hexToRgba(backgroundColor) : '000000'}
      $backgroundColorEnd={
        (configData?.display_one_team === '1' ||
          configData?.display_one_team === 1) &&
        Boolean(configData?.style_main_color)
          ? mainColorRgba(0)
          : null
      }
      $backgroundColorStart={
        (configData?.display_one_team === '1' ||
          configData?.display_one_team === 1) &&
        Boolean(configData?.style_main_color)
          ? mainColorRgba(0.5)
          : null
      }
      $hasTopNav={isTopNavEnabled}
    >
      {isTopNavEnabled ? <TopNav /> : null}
      <StyledHeader>
        {/* <AuthContainer /> */}
        <ChampionshipHeader
          configuration={configData || null}
          leagues={leaguesData}
        />
      </StyledHeader>

      <MainContainer>
        <DashboardChampionship
          currentGame={teamsData.currentGame}
          games={teamsData.data}
        />
      </MainContainer>
      <StyledFooter />
    </BodyContainer>
  );
};

export default ChampionshipPage;
